export default {"src":"/login-app/[GIT_HASH]/_next/static/media/file_pdf.ecf997f7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};